import {default as React, useState} from 'react';
import {Button, Checkbox, Modal, Table} from 'semantic-ui-react';
import {ColumnDefinition} from './common';
import i18n from '../../../../locale/i18n';

const t = i18n.t.bind(i18n);

interface ColumnSelectionProps {
  availableColumns: ColumnDefinition[];
  selectedColumns: string[];

  onSave(columns: string[]): void;
  onCancel?(): void;
}

export interface ColumnSelectionButtonProps extends ColumnSelectionProps {
  fluid?:boolean;
}

export const ColumnSelectionButton = (props: ColumnSelectionButtonProps) => {
  const [isVisible, setIsVisible] = useState(false);

  return (<>
    <Button icon="columns"
            onClick={() => setIsVisible(true)}
            content={t("Common.SelectColumns")}
            fluid={props.fluid}
    />
    <ColumnSelectionModal
        visible={isVisible}
        availableColumns={props.availableColumns}
        selectedColumns={props.selectedColumns}
        onSave={(columns) => {
          setIsVisible(false);
          props.onSave(columns);
        }}
        onCancel={() => {
          setIsVisible(false);
          if(props.onCancel) {
            props.onCancel();
          }
        }} />
    </>);
};

export interface ColumnSelectionModalProps extends ColumnSelectionProps {
  visible?: boolean;
}

export const ColumnSelectionModal = (props: ColumnSelectionModalProps) => {
  const [selected, updateSelected] = useState(props.selectedColumns);

  function isSelected(column: ColumnDefinition) {
    return selected.indexOf(column.fieldName) !== -1;
  }

  function setSelectionState(column: ColumnDefinition, newState: boolean) {
    if(newState) {
      updateSelected(prevState => {
        if(prevState.indexOf(column.fieldName) !== -1) {
          return prevState;
        }
        return [...prevState, column.fieldName];
      });
    } else {
      if(column.required) {
        return;
      }
      updateSelected(prevState => {
        return [...prevState].filter(c => c !== column.fieldName);
      })
    }
  }

  return (
      <Modal open={props.visible}>
        <Modal.Header>{t("Common.SelectColumns")}</Modal.Header>
        <Modal.Content>
          <Table unstackable={true}>
            <Table.Body>
              {props.availableColumns.map((column, columnIndex) => (
                  <Table.Row key={`column_${columnIndex}`}>
                    <Table.Cell collapsing>
                      <Checkbox disabled={column.required} checked={isSelected(column)} onClick={(_, data) => setSelectionState(column, !!data.checked)} />
                    </Table.Cell>
                    <Table.Cell style={{paddingLeft: '1em', fontWeight: 'bold'}}>
                      {column.labelTranslationKey? t(column.labelTranslationKey) : column.label}
                    </Table.Cell>
                  </Table.Row>))}
            </Table.Body>
          </Table>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={props.onCancel}>{t("Common.Cancel")}</Button>
          <Button onClick={() => props.onSave(selected)} primary>{t("Common.Apply")}</Button>
        </Modal.Actions>
      </Modal>
  );
};